import { useRouter } from 'next/router';
import { useCallback } from 'react';
import {
  fetchLargeCategories,
  fetchMiddleCategories,
  fetchSmallCategories,
  fetchTinyCategories
} from 'src/libs/api/categoryApi';
import type { Category } from 'src/stores/Category';
import useSWR from 'swr';

export const useCategory = (): {
  category: Category | undefined;
  isLoading: boolean;
  isError: boolean;
} => {
  const { locale } = useRouter();
  const fetcher = useCallback(async (key: string[]): Promise<Category> => {
    const [largeCategories, middleCategories, smallCategories, tinyCategories] = await Promise.all([
      fetchLargeCategories(key[1]),
      fetchMiddleCategories(key[1]),
      fetchSmallCategories(key[1]),
      fetchTinyCategories(key[1])
    ]);
    return {
      largeCategories: largeCategories,
      middleCategories: middleCategories,
      smallCategories: smallCategories,
      tinyCategories: tinyCategories
    };
  }, []);
  const { data, isLoading, error } = useSWR(locale ? ['/api/category', locale] : null, fetcher, {
    errorRetryCount: 0,
    dedupingInterval: 86400000,
    fallbackData: {
      largeCategories: [],
      middleCategories: [],
      smallCategories: [],
      tinyCategories: []
    }
  });

  return {
    category: data,
    isLoading,
    isError: !!error
  };
};
